// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./static/mobile_login_background.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("static/web_login_background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.authorization-view {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.authorization-background-image {
    position: absolute;
    background-size: cover;
    width: 100%;
    height: 370px;
    top: 0;
    background: #FFFFFF url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
    background-size: cover;
}


.login-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    z-index: 2;
}

.login-description {
    width: 355px;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    text-align: center;
    color: #FFFFFF;
    margin-bottom: 40px;
    height: fit-content;
}


.login-verification-error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    width: 80%;
    color: #ED2B2B;
    font-weight: 600;
}

html[lang="ru"] .login-description, .login-verification-error, .send-again-button, .send-again-text {
    font-weight: 500;
}

.login-input-container {
    position: relative;
    margin-top: 10px;
}

.eye-icon {
    position: absolute;
    right: 15px;
    top: 45%;
    transform: translateY(-50%);
    cursor: pointer;
    color: #444444e0;
}

.verification-description {
    font-weight: 700;
    font-size: 24px;
    line-height: 31px;
    text-align: center;
    color: #FFFFFF;
    margin-bottom: 20px;
}

.login-input {
    direction: ltr;
    width: 269px;
    height: 50px;
    background: #FFFFFF;
    border: 1px solid #ADACAC;
    border-radius: 3px;
    font-weight: 400;
    font-size: 16px;
    line-height: 21px;
    text-align: center;
    color: #474747;
    margin-bottom: 12px;
}

.login-input::placeholder {
    color: #474747;
}

.login-input:focus {
    outline: none;
}

/* Remove arrows from input type number*/
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type="number"] {
    -moz-appearance: textfield;
}

.send-again-text, .wait-text {
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    color: #3748DE;
}

.send-again-button {
    text-decoration: underline;
    cursor: pointer;
}

.send-again-button-clicked {
    font-weight: bold;
    text-decoration: none;
    cursor: pointer;
}

.login-button {
    align-items: center;
    height: 55px;
    width: 275px;
    background-color: #F59544;
    border-radius: 10px;
    font-weight: 400;
    font-size: 18px;
    border: none;
    margin: 15px;
    cursor: pointer;
    color: #FFFFFF;
}

.login-button:disabled {
    opacity: 50%;
    cursor: not-allowed;
    position: relative;
}

.login-button__text {
    font: bold 20px 'Quicksand', san-serif;
    color: #ffffff;
    transition: all 0.2s;
}

@keyframes button-loading-spinner {
    from {
        transform: rotate(0turn);
    }

    to {
        transform: rotate(1turn);
    }
}

.login-button.loading::after {
    content: "";
    position: absolute;
    width: 16px;
    height: 16px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border: 4px solid transparent;
    border-top-color: #ffffff;
    border-radius: 50%;
    animation: button-loading-spinner 1s ease infinite;
}

.login-modal {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.login-modal-content {
    padding: 25px 25px 40px;
    box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.25);
    background-color: #FFFFFF;
    width: 70%;
    font-weight: 600;
    font-size: 20px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
    border: none;
    flex-direction: column;
}

.login-modal-relogin-text {
    font-weight: 400;
    font-size: 20px;
    line-height: 140%;
    margin: unset;
}


.exit-button-modal {
    background: #F59544;
    border-radius: 10px;
    align-items: center;
    height: 45px;
    font-weight: 400;
    font-size: 18px;
    border: none;
    cursor: pointer;
    color: #FFFFFF;
    float: left;
    margin-top: 30px;
    white-space: nowrap;
    text-align: center;
    padding-bottom: 5px;
}

.spinner-container {
    display: flex;
    align-items: center;
    gap: 16px;
}

.spinner-wrapper {
    position: relative;
    width: 25px;
    height: 25px;
}

.spinner {
    border: 2px solid #f3f3f3;
    border-top: 2px solid #F59544;
    border-radius: 50%;
    width: 100%;
    height: 100%;
    animation: spin 2s linear infinite;
}

.timer {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
    color: #3748DE;
    font-weight: bold;
    z-index: 1;
    padding-right: 5px;
    padding-top: 2px;

}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@media only screen and (min-width: 450px) {
    .authorization-view {
        margin-bottom: 200px;
    }

    .authorization-background-image {
        background: #FFFFFF url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
        top: 0;
        left: 0;
        height: 900px;
        background-size: cover;
        z-index: -1;
        width: 100%;
    }

    .login-description {
        font-weight: 600;
        font-size: 20px;
        line-height: 26px;
        color: #212121;
        width: 440px;
        padding: 10px;
        margin-bottom: 30px;
    }

    html[lang="ru"] .login-description {
        width: 480px;
    }

    .login-container {
        width: 550px;
        height: 360px;
        background: #FFFFFF;
        box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.21);
        border-radius: 25px;
        padding-top: 15px;
    }


    .login-modal {
        width: 50%;
    }

    .login-modal-content {
        font-weight: 600;
        font-size: 24px;
        line-height: 31px;
        text-align: center;
        color: #212121;
        height: 220px;
        justify-content: center;
    }

    .exit-button-modal {
        width: 269px;
        height: 54px;
        filter: drop-shadow(1px 2px 4px rgba(0, 0, 0, 0.25));
    }

}`, "",{"version":3,"sources":["webpack://./src/Authorization.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,MAAM;IACN,4EAAgF;IAChF,sBAAsB;AAC1B;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA,wCAAwC;AACxC;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,2CAA2C;IAC3C,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;AACjB;;;AAGA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,UAAU;IACV,kBAAkB;IAClB,gBAAgB;;AAEpB;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,4EAA2E;QAC3E,MAAM;QACN,OAAO;QACP,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,cAAc;QACd,YAAY;QACZ,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,2CAA2C;QAC3C,mBAAmB;QACnB,iBAAiB;IACrB;;;IAGA;QACI,UAAU;IACd;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,cAAc;QACd,aAAa;QACb,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,oDAAoD;IACxD;;AAEJ","sourcesContent":["\n.authorization-view {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.authorization-background-image {\n    position: absolute;\n    background-size: cover;\n    width: 100%;\n    height: 370px;\n    top: 0;\n    background: #FFFFFF url(\"./static/mobile_login_background.png\") no-repeat center;\n    background-size: cover;\n}\n\n\n.login-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    z-index: 2;\n}\n\n.login-description {\n    width: 355px;\n    font-weight: 600;\n    font-size: 17px;\n    line-height: 22px;\n    text-align: center;\n    color: #FFFFFF;\n    margin-bottom: 40px;\n    height: fit-content;\n}\n\n\n.login-verification-error {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    align-items: center;\n    width: 80%;\n    color: #ED2B2B;\n    font-weight: 600;\n}\n\nhtml[lang=\"ru\"] .login-description, .login-verification-error, .send-again-button, .send-again-text {\n    font-weight: 500;\n}\n\n.login-input-container {\n    position: relative;\n    margin-top: 10px;\n}\n\n.eye-icon {\n    position: absolute;\n    right: 15px;\n    top: 45%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    color: #444444e0;\n}\n\n.verification-description {\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 31px;\n    text-align: center;\n    color: #FFFFFF;\n    margin-bottom: 20px;\n}\n\n.login-input {\n    direction: ltr;\n    width: 269px;\n    height: 50px;\n    background: #FFFFFF;\n    border: 1px solid #ADACAC;\n    border-radius: 3px;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 21px;\n    text-align: center;\n    color: #474747;\n    margin-bottom: 12px;\n}\n\n.login-input::placeholder {\n    color: #474747;\n}\n\n.login-input:focus {\n    outline: none;\n}\n\n/* Remove arrows from input type number*/\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\ninput[type=\"number\"] {\n    -moz-appearance: textfield;\n}\n\n.send-again-text, .wait-text {\n    font-weight: 600;\n    font-size: 15px;\n    line-height: 20px;\n    text-align: center;\n    color: #3748DE;\n}\n\n.send-again-button {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.send-again-button-clicked {\n    font-weight: bold;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.login-button {\n    align-items: center;\n    height: 55px;\n    width: 275px;\n    background-color: #F59544;\n    border-radius: 10px;\n    font-weight: 400;\n    font-size: 18px;\n    border: none;\n    margin: 15px;\n    cursor: pointer;\n    color: #FFFFFF;\n}\n\n.login-button:disabled {\n    opacity: 50%;\n    cursor: not-allowed;\n    position: relative;\n}\n\n.login-button__text {\n    font: bold 20px 'Quicksand', san-serif;\n    color: #ffffff;\n    transition: all 0.2s;\n}\n\n@keyframes button-loading-spinner {\n    from {\n        transform: rotate(0turn);\n    }\n\n    to {\n        transform: rotate(1turn);\n    }\n}\n\n.login-button.loading::after {\n    content: \"\";\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: auto;\n    border: 4px solid transparent;\n    border-top-color: #ffffff;\n    border-radius: 50%;\n    animation: button-loading-spinner 1s ease infinite;\n}\n\n.login-modal {\n    position: relative;\n    z-index: 2;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.login-modal-content {\n    padding: 25px 25px 40px;\n    box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.25);\n    background-color: #FFFFFF;\n    width: 70%;\n    font-weight: 600;\n    font-size: 20px;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    color: #000000;\n    border: none;\n    flex-direction: column;\n}\n\n.login-modal-relogin-text {\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 140%;\n    margin: unset;\n}\n\n\n.exit-button-modal {\n    background: #F59544;\n    border-radius: 10px;\n    align-items: center;\n    height: 45px;\n    font-weight: 400;\n    font-size: 18px;\n    border: none;\n    cursor: pointer;\n    color: #FFFFFF;\n    float: left;\n    margin-top: 30px;\n    white-space: nowrap;\n    text-align: center;\n    padding-bottom: 5px;\n}\n\n.spinner-container {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.spinner-wrapper {\n    position: relative;\n    width: 25px;\n    height: 25px;\n}\n\n.spinner {\n    border: 2px solid #f3f3f3;\n    border-top: 2px solid #F59544;\n    border-radius: 50%;\n    width: 100%;\n    height: 100%;\n    animation: spin 2s linear infinite;\n}\n\n.timer {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 14px;\n    color: #3748DE;\n    font-weight: bold;\n    z-index: 1;\n    padding-right: 5px;\n    padding-top: 2px;\n\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@media only screen and (min-width: 450px) {\n    .authorization-view {\n        margin-bottom: 200px;\n    }\n\n    .authorization-background-image {\n        background: #FFFFFF url(\"static/web_login_background.png\") no-repeat center;\n        top: 0;\n        left: 0;\n        height: 900px;\n        background-size: cover;\n        z-index: -1;\n        width: 100%;\n    }\n\n    .login-description {\n        font-weight: 600;\n        font-size: 20px;\n        line-height: 26px;\n        color: #212121;\n        width: 440px;\n        padding: 10px;\n        margin-bottom: 30px;\n    }\n\n    html[lang=\"ru\"] .login-description {\n        width: 480px;\n    }\n\n    .login-container {\n        width: 550px;\n        height: 360px;\n        background: #FFFFFF;\n        box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.21);\n        border-radius: 25px;\n        padding-top: 15px;\n    }\n\n\n    .login-modal {\n        width: 50%;\n    }\n\n    .login-modal-content {\n        font-weight: 600;\n        font-size: 24px;\n        line-height: 31px;\n        text-align: center;\n        color: #212121;\n        height: 220px;\n        justify-content: center;\n    }\n\n    .exit-button-modal {\n        width: 269px;\n        height: 54px;\n        filter: drop-shadow(1px 2px 4px rgba(0, 0, 0, 0.25));\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
